import { configureStore } from "@reduxjs/toolkit"
import { apiSlice } from "../Api/apiSlice.js"

export const store = configureStore({
    reducer:{
        [apiSlice.reducerPath]: apiSlice.reducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(apiSlice.middleware)
})